import type { Account } from '@calculom/report-designer';

export const MOCK_ACCOUNTS: Account[] = [
  // Revenue
  { code: '4000', name: 'Revenue', type: 'revenue', parent: null },
  { code: '4100', name: 'Product Sales', type: 'revenue', parent: '4000' },
  { code: '4200', name: 'Service Revenue', type: 'revenue', parent: '4000' },
  { code: '4300', name: 'Other Income', type: 'revenue', parent: '4000' },

  // Expenses
  { code: '5000', name: 'Expenses', type: 'expense', parent: null },
  { code: '5100', name: 'Cost of Goods Sold', type: 'expense', parent: '5000' },
  { code: '5200', name: 'Salaries & Wages', type: 'expense', parent: '5000' },
  { code: '5300', name: 'Rent Expense', type: 'expense', parent: '5000' },
  { code: '5400', name: 'Utilities', type: 'expense', parent: '5000' },
  { code: '5500', name: 'Depreciation', type: 'expense', parent: '5000' },
  { code: '5600', name: 'Marketing', type: 'expense', parent: '5000' },
  { code: '5700', name: 'Insurance', type: 'expense', parent: '5000' },

  // Assets
  { code: '1000', name: 'Assets', type: 'asset', parent: null },
  { code: '1100', name: 'Cash & Equivalents', type: 'asset', parent: '1000' },
  { code: '1200', name: 'Accounts Receivable', type: 'asset', parent: '1000' },
  { code: '1300', name: 'Inventory', type: 'asset', parent: '1000' },
  { code: '1400', name: 'Prepaid Expenses', type: 'asset', parent: '1000' },
  { code: '1500', name: 'Property & Equipment', type: 'asset', parent: '1000' },

  // Liabilities
  { code: '2000', name: 'Liabilities', type: 'liability', parent: null },
  { code: '2100', name: 'Accounts Payable', type: 'liability', parent: '2000' },
  { code: '2200', name: 'Accrued Liabilities', type: 'liability', parent: '2000' },
  { code: '2300', name: 'Long-Term Debt', type: 'liability', parent: '2000' },

  // Equity
  { code: '3000', name: 'Equity', type: 'equity', parent: null },
  { code: '3100', name: 'Common Stock', type: 'equity', parent: '3000' },
  { code: '3200', name: 'Retained Earnings', type: 'equity', parent: '3000' },
];
